import { siteConfig } from '../data/siteConfig';

/**
 * Meta Pixel (browser) for InstaMovers Florida's dataset.
 * Only standard events with non-personal parameters — never names, emails, phones, addresses, notes or inventory.
 */
type Fbq = ((...args: unknown[]) => void) & { callMethod?: (...a: unknown[]) => void; queue: unknown[][]; push: Fbq; loaded: boolean; version: string };

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

let initialized = false;
let pageViewFired = false;

function pixelId(): string | null {
  const id = siteConfig.metaPixelId?.trim();
  return id ? id : null;
}

/** Loads fbevents.js and calls init once (standard Meta base code). */
export function initPixel(): boolean {
  const id = pixelId();
  if (!id || typeof window === 'undefined') return false;
  if (initialized) return true;
  if (!window.fbq) {
    const n = function (...args: unknown[]) {
      if (n.callMethod) n.callMethod(...args);
      else n.queue.push(args);
    } as Fbq;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    window.fbq = n;
    if (!window._fbq) window._fbq = n;
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    if (first?.parentNode) first.parentNode.insertBefore(s, first);
    else document.head.appendChild(s);
  }
  window.fbq('init', id);
  initialized = true;
  return true;
}

/** PageView once per page load (the funnel is a single page; step changes are not new page loads). */
export function firePageView(): void {
  if (pageViewFired || !initPixel()) return;
  pageViewFired = true;
  window.fbq?.('track', 'PageView');
}

/** AddToCart when the customer clicks the button that sends them to Shopify. Value = the deposit amount in the cart, not the move estimate. */
export function fireAddToCart(value: number, eventId: string): void {
  if (!initPixel()) return;
  window.fbq?.('track', 'AddToCart', { value, currency: 'USD', content_type: 'product', content_name: 'Moving deposit' }, { eventID: eventId });
}
